export default __webpack_public_path__ + "ce76128d8ee1d7b0eefb865187b67662.svg";